import React from "react";
import * as S from "./styles";

const LoadingSpinner = () => {
  return (
    <S.SpinnerContainer>
      <div className={"spinner"} />
    </S.SpinnerContainer>
  );
};

export default LoadingSpinner;
